/**
 * @prettier
 */
export const KEY_NAME = 'posInterfaceLargerEnabled';

export function setPosInterfaceLargerEnabledRestaurantSettingInLocalStorage(value: boolean | undefined): void {
    window.localStorage.setItem(KEY_NAME, value === true ? 'true' : 'false');
}
